import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import Remove from '@/icons/delete.svg';
import Edit from '@/icons/edit.svg';

import { EditFolderName, RemoveFolder } from './modals';

export function useOptions() {
	const { t } = useTranslation();
	const [openOption, setOpenOption] = useState(null);

	const options = [
		{
			name: 'edit',
			label: t('myDocuments.folders.editName'),
			Component: EditFolderName,
			Icon: Edit
		},
		{
			name: 'delete',
			label: t('common.delete'),
			Component: RemoveFolder,
			Icon: Remove
		}
	];

	return {
		options,
		openOption,
		setOpenOption
	};
}
